import BaseApi from "../baseApi";

export default class DebitorApi extends BaseApi {
    async getDebitorSettings(debitorNo: string): Promise<DebitorSettings> {
        const url = `/api/DebitorSettings/${debitorNo}`;
        return await this.fetchGet(url);
    }

    async setDebitorSettings(debitorSetting: DebitorSettings): Promise<DebitorSettings> {
        const url = `/api/DebitorSettings/set`;
        return await this.fetchPost(url, debitorSetting);
    }
}
